export default {
  // / <summary>
  // / File tạm
  // / </summary>
  Temp: 0,
  /// <summary>
  /// Các file dữ liệu mang đi
  /// </summary>
  SystemData: 1,
  /// <summary>
  /// Script sql của đăng ký dữ liệu
  /// </summary>
  Register: 2,
  /// <summary>
  /// File đính kèm
  /// </summary>
  Attachment: 3,
  /// <summary>
  /// Script nâng cấp dữ liệu khách hàng
  /// Trong này sẽ chia các thư mục nhỏ theo từng bản build
  /// 1.0.0.1, 1.0.0.2....
  /// </summary>
  SqlUpgradeTenant: 4,
  /// <summary>
  /// Script nâng cấp dữ liệu system
  /// Trong này sẽ chia các thư mục nhỏ theo từng bản build
  /// 1.0.0.1, 1.0.0.2....
  /// </summary>
  SqlUpgradeSystem: 5,
  /// <summary>
  /// Script nâng cấp dữ liệu manage
  /// Trong này sẽ chia các thư mục nhỏ theo từng bản build
  /// 1.0.0.1, 1.0.0.2....
  /// </summary>
  SqlUpgradeManage: 6,
  /// <summary>
  /// file script nâng cấp db queue
  /// </summary>
  SqlUpgradeQueue: 7,
  /// <summary>
  /// Mẫu báo cáo: Chung cho mrt, xslt
  /// </summary>
  ReportTemplate: 10,
  /// <summary>
  /// Ảnh nền của mẫu xslt
  /// </summary>
  ReportXsltBackground: 11,

  /// <summary>
  /// Cập nhật MisaCodeID
  /// </summary>
  UpdateMisaCodeID: 12,

  /// <summary>
  /// Các file cập nhật dư thừa
  /// </summary>
  RedundantUpdating: 13,

  /// <summary>
  /// Các file nhập khẩu mẫu
  /// </summary>
  ImportTemplate: 14,
  /// <summary>
  /// Các File biểu mẫu thuyết minh
  /// </summary>
  ExplanationForm: 15,
  /// <summary>
  /// thuyết minh dự toán thu chi lưu trên storage
  /// </summary>
  EstimateStorageExplanation: 16,
  /// <summary>
  /// thuyết minh mặc định
  /// </summary>
  EstimateStorageExplanationDefault: 17,

  // Nộp dự toán
  SubmitEstimate: 19,

  // nộp dự toán lấy lên dữ liệu
  SubmitEstimateDetail: 20,

  // đính kèm dự toán nhu cầu
  AuditReceiveAttachement: 26,

  /// <summary>
  /// thuyết minh dự toán thu chi lưu trên storage (Kiểm tra)
  /// </summary>
  AuditEstimateStorageExplanation: 27,

  /// <summary>
  /// Mẫu thuyết minh của đơ vị cấp dưới (nhu cầu)
  /// </summary>
  AuditEstimateEstimateExplanationForm: 28,

  /// <summary>
  /// Đính kèm (Kiểm tra)
  /// </summary>
  AuditEstimateAttachment: 29,

  /// <summary>
  /// thuyết minh dự toán cân đối lưu trên storage
  /// </summary>
  EstimateArrgrateStorageExplanation: 36,

  /// <summary>
  /// thuyết minh dự toán cân toàn ngành trên storage
  /// </summary>
  EstimateSectorWideStorageExplanation: 42,

  /// <summary>
  /// đính kèm dự toán toàn ngành lưu trên storage
  /// </summary>
  EstimateSectorWideAttachment: 43,

  /// <summary>
  /// đính kèm dự toán cân đối lưu trên storage
  /// </summary>
  EstimateArrgrateAttachment: 44,

  AuditReceiveSectorWide: 48,

  /// <summary>
  /// đính kèm dự toán cân đối lưu trên storage
  /// </summary>
  AuditArrgrateAttachment: 49,

  /// <summary>
  /// đính kèm nộp dự toán cân đối lưu trên storage
  /// </summary>
  SubmitSectorWideAttachment: 50,

  /// <summary>
  /// dự toán nộp lập và cân đối
  /// </summary>
  SubmitEstimateArrgrate: 51,

  AuditReceiveArrgrate: 53,
  /// <summary>
  /// nhận đính kèm
  /// </summary>
  ReturnEstArrgrateAttachment: 54,

  /// <summary>
  /// File đính kèm Nộp dự toán 3 năm
  /// </summary>
  SubmitEstimateThreeYearAttachment: 55,

  /// <summary>
  /// File đính kèm Nộp dự toán 3 năm toàn ngành
  /// </summary>
  SubmitEstimateArrgrateThreeYearAttachment: 58,

  /// <summary>
  /// STC nhận quyết định giao
  /// </summary>
  AllocationSTCSuperior: 61,

  /// <summary>
  /// File đính kèm hệ số lương
  /// </summary>
  AuditEstimateSalaryCoeficient: 2709,
  /// <summary>
  /// File đính kèm hệ số lương
  /// </summary>
  SubmitEstimateSalaryCoeficient: 2710,

  /// <summary>
  /// File đính kèm phương án phân bổ
  /// </summary>
  AllocationImplementAttachment: 62,
  /// <summary>
  /// Thuyết minh phân bổ
  /// </summary>
  AllocationImplementStorege: 2004,

  /**
   * đính kèm lập đầu năm
   */
  EstInitialAttachment: 2008,
  /**
   * mẫu báo cáo của STC
   */
  ReportTemplateFile : 2025,

  /**
   * đính kèm kiểm tra dự toán nhu cầu đầu năm
   */
  AuditReceiveInitialAttachment: 2035,

  /**
   * Đính kèm Kiểm tra đầu năm
   */
  AuditEstInitialAttachment: 1999,
  EstInitialSectorWideStorageExplanation: 2040,
  EstInitialSectorWideAttachment: 2041,

};
